import { useEffect, useRef, useState } from 'react'
import { ParallaxProvider, Parallax, ParallaxBanner, ParallaxBannerLayer } from "react-scroll-parallax";
import 'primeicons/primeicons.css';
import toast from "react-hot-toast";
import { useLocation, useNavigate } from "react-router-dom";
import "./index.scss"
import SearchProducts from '../../../header/components/search/search';
import { LoginOfferCards } from '../login-offer-card';
import { HomePageCarouselFilter, HomePageCarouselType } from '../../constant/hompage.constant';
import OfferCardShimmer from '../OfferCardShimmer/OfferCardShimmer';
import { getData, postData } from '../../../../services/global.service';
import { API_CONSTANTS } from '../../../../constants/search.constanst';
import { APIEnv, APIStatus } from '../../../../interface/baseInterfaces';
import { checkIsUserLoggedIn, getDataFromLocalStorage, initializeCheckoutData, redirectToReactCart, redirectToReactLogin, setDataOnLocalStorage } from '../../../../utils/globalUtilities';
import { Dropdown } from 'primereact/dropdown';


interface LogInHomePageProps {
    practicePopularTopics: any
    caseLawsData: any
    caseLawsFilterData: any
    CirNottData: any
    learningVideosData: any
    filterSelected: Function
    setSelectedTab: any
    selectedTab: any,
    caseLawsLoading: boolean, 
    cirNotLoading: boolean, 
    practiceTopicLoading: boolean, 
    learningVideosLoading: boolean,
    onClickViewAll?: any,
    cirnotFilterData:any,
    filterSelectedCirnotType?:Function,
    researchTopics:any,
    researchFilterData:any,
    filterSelectedResearchTab?:Function,
    practiceFilterData:any,
    filterSelectedPracticeTab?:Function,
    learningFilterData:any,
    filterSelectedLearningTab?:Function,
}
export const LoginHomePage = ({ practicePopularTopics, learningVideosData, filterSelected, selectedTab, setSelectedTab, onClickViewAll, caseLawsLoading, practiceTopicLoading, learningVideosLoading, practiceFilterData,filterSelectedPracticeTab, learningFilterData, filterSelectedLearningTab, researchTopics, researchFilterData,filterSelectedResearchTab}: LogInHomePageProps) => {
    const [selectedSection, setSelectedSection] = useState<string>(HomePageCarouselType.RESEARCH);

    const location = useLocation();
    useEffect(() => {
        if (location.hash) {
            const element = document.getElementById(location.hash.substring(1));
            if (element) {
                element.scrollIntoView({ behavior: "smooth" });
            }
        }
    }, [location]);
   
 useEffect(() => {
    const sections = [
      { ref: researchRef, type: HomePageCarouselType.RESEARCH },
      { ref: practiceRef, type: HomePageCarouselType.PRACTICE },
      { ref: videosRef, type: HomePageCarouselType.VIDEO },
    ];

   const observerOptions = {
     root: null, // Observe within the viewport
     threshold: 0.5, // 50% of the section must be visible
   };

   const observer = new IntersectionObserver((entries) => {
     entries.forEach((entry) => {
       if (entry.isIntersecting) {
         // Update the active section based on the visible section
         const visibleSection = sections.find(
           (section) => section.ref.current === entry.target
         );
         if (visibleSection) {
           setSelectedSection(visibleSection.type);
         }
       }
     });
   }, observerOptions);

   // Start observing each section
   sections.forEach((section) => {
     if (section.ref.current) observer.observe(section.ref.current);
   });

   // Cleanup on unmount
   return () => {
     sections.forEach((section) => {
       if (section.ref.current) observer.unobserve(section.ref.current);
     });
   };
 });


 const handleScrollToSection = (ref: any, type: string) => {
  const element = ref.current;
  if (element) {
    const headerHeight = 120;
    const elementTop = element.getBoundingClientRect().top + window.pageYOffset;
    const offsetPosition = elementTop - headerHeight;
    const indexArray = ['research', 'practice', 'video'];
    
    const currentSectionIndex = indexArray.indexOf(selectedSection);
    
    const clickedSectionIndex = indexArray.indexOf(type);
    

      if (clickedSectionIndex < currentSectionIndex) {
        if(currentSectionIndex-clickedSectionIndex == 1){
          window.scrollTo({
            top:window.pageYOffset - ref.current.offsetHeight - 30,
            behavior: "smooth"
          });
        }
        else{
          window.scrollTo({
            top:window.pageYOffset - (ref.current.offsetHeight + ref.current.offsetHeight) - 100,
            behavior: "smooth"
          });
        }
        
        return
      } 
      window.scrollTo({
        top: offsetPosition,
        behavior: "smooth"
      });
    
    setSelectedSection(type);
  }
};


      
const options = [
  { label: 'All', value: 0 },
  { label: 'GST', value: 1 },
  { label: 'Income Tax', value: 2 }
];


/* sticky */
const practiceRef = useRef<HTMLDivElement | null>(null);
  const videosRef = useRef<HTMLDivElement | null>(null);
  const researchRef = useRef<HTMLDivElement | null>(null);

  const [stickyElement, setStickyElement] = useState<string | null>(null);

  useEffect(() => {
    const handleScroll = () => {
      const checkSticky = (ref: React.RefObject<HTMLDivElement>, sectionName: string) => {
        if (!ref.current) return;

        const rect = ref.current.getBoundingClientRect();
        if (rect.top <= 400) {
          setStickyElement(sectionName); // Mark as fully stuck at the top
        } else if (stickyElement === sectionName) {
          setStickyElement(null); // Remove when it scrolls away
        }
      };
      checkSticky(researchRef,"research");
      checkSticky(practiceRef, "practice");
      checkSticky(videosRef, "videos");
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, [stickyElement]);

    return (
        <>

<ParallaxProvider>

<div className="sec-banners-login">

  <ParallaxBanner
    layers={[
      {
        children: (
          <video
            autoPlay
            loop
            muted
            playsInline
            className="video-banner"
          >
            <source src="https://cdn.taxmann.com/taxmann-images/taxmann-premium/premium-video-banner-login.mp4" type="video/mp4" />
            Your browser does not support the video tag.
          </video>
        ),
        speed: -10, // Controls the parallax effect
      },
    ]}
    style={{
       
      width: "100%",   // Full width
      //position: "absolute",
      inset: "0", // Ensures it starts at the top
    }}
    className='ParallaxBannerLayer'
  >
    <div className="banners-contents">
      <Parallax speed={-10}>
        {/* <h2 className="logo-banner"> <img src="https://cdn.taxmann.com/taxmann-images/taxmann-premium/premium-banner-logo.png"></img> </h2> */}
        <h2 className="screens-heading-1">Unifying <span className='text-highlight-green'>  Research </span> | <span className='text-highlight-blue'> Practice </span> | <span className='text-highlight-b-cyan'> Learning</span>—Seamlessly</h2>
        <div className='banner-search'> <span className="search-items">  <SearchProducts type={'HOME'}  /> </span> </div>
        
      </Parallax>
    </div>
  </ParallaxBanner>




</div>


           
            <div className="max-container-ui2 max-container-ui-mob">
                
               
                <div className='section-default-2'>
                    <div className="sub_head">
                        <h1 className='search_platform_head'>Taxmann.com | Premium—The <span className='color_highlight'>Unified Search Platform </span> <br></br>
                        Built Around Your Needs </h1>
                    </div>

                    <div className="mini_headings">
                        <div className='access'>
                          <p className='access_para'>With Premium, you can access: <span className='access_line'> |</span></p>
                        </div>
                        <div className="sub_headings">
                            {/* Navigation Tabs */}
      <ul className="search_platform_options access_tabs">
        <li
          className={
            selectedSection === "research" ? "active_options" : ""
          }
        >
          
          <a
            className="link-a"
            onClick={() => handleScrollToSection(researchRef, "research")}
          >
            Research
          </a>
         
        </li>
        
        <li
          className={selectedSection === "practice" ? "active_options" : ""}
        >
         
          <a
            className="link-a"
            onClick={() => handleScrollToSection(practiceRef, "practice")}
          >
            Practice
          </a>
        
        </li>
        <li
          className={selectedSection === "video" ? "active_options" : ""}
        >
          
          <a
            className="link-a"
            onClick={() => handleScrollToSection(videosRef, "video")}
          >
            Learning
          </a>
         
        </li>
      </ul>
                        </div>
                        <div className="sub_main_headings">
                          <Dropdown
                          value={selectedTab}
                          options={options}
                          onChange={(e) => setSelectedTab(e.value)}
                          optionLabel="label"
                          placeholder="Select Type"
                          className="input_width"
                          />
                        </div>
                    </div>

                    <div className='tab-containts'>
<div className='tab-containt-wrapper'> 

 



                        {
                            researchTopics?.length ?
                                <div ref={researchRef} className={`research_learnings_1 section-offset ${stickyElement === "research" ? "fully-sticky" : ""}`} >
                                  <div className='section-indicator-1'> 01/<span className='text-light-1'>03</span> <svg width="25" height="15" viewBox="0 0 25 15" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M24.7071 8.20711C25.0976 7.81658 25.0976 7.18342 24.7071 6.79289L18.3431 0.428932C17.9526 0.0384078 17.3195 0.0384078 16.9289 0.428932C16.5384 0.819457 16.5384 1.45262 16.9289 1.84315L22.5858 7.5L16.9289 13.1569C16.5384 13.5474 16.5384 14.1805 16.9289 14.5711C17.3195 14.9616 17.9526 14.9616 18.3431 14.5711L24.7071 8.20711ZM0 8.5H24V6.5H0V8.5Z" fill="#5DBD77"/>
</svg>
 </div>
                                    <LoginOfferCards
                                        title={"Research"}
                                        apiresponse={researchTopics}
                                        showReadMore={true}
                                        numVisible={4}
                                        onClickViewAll={onClickViewAll}
                                        type={HomePageCarouselType.RESEARCH}
                                        selectedTab={selectedTab}
                                        filterType={selectedTab==0?HomePageCarouselFilter.ALL:(selectedTab==1?HomePageCarouselFilter.GST:HomePageCarouselFilter.INCOME_TAX)}
                                        isfilter={true}
                                        isVideos={false}
                                        filterData={researchFilterData}
                                        filterSelectedResearchTab={filterSelectedResearchTab}

                                    />
                                </div>
                                : 
                                caseLawsLoading ?
                                <OfferCardShimmer />
                                :''                        }


                        {
                            practicePopularTopics?.length ?
                                <>
                                <div ref={practiceRef} className={`practice_learnings_1 section-offset ${stickyElement === "practice" ? "fully-sticky" : ""}`}>
                                <div className='section-indicator-1'> 02/<span className='text-light-1'>03</span> <svg width="25" height="15" viewBox="0 0 25 15" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M24.7071 8.20711C25.0976 7.81658 25.0976 7.18342 24.7071 6.79289L18.3431 0.428932C17.9526 0.0384078 17.3195 0.0384078 16.9289 0.428932C16.5384 0.819457 16.5384 1.45262 16.9289 1.84315L22.5858 7.5L16.9289 13.1569C16.5384 13.5474 16.5384 14.1805 16.9289 14.5711C17.3195 14.9616 17.9526 14.9616 18.3431 14.5711L24.7071 8.20711ZM0 8.5H24V6.5H0V8.5Z" fill="#2698FA"/>
</svg>

 </div>
                                    <LoginOfferCards
                                        title={"Practice"}
                                        apiresponse={practicePopularTopics}
                                        showReadMore={true}
                                        numVisible={4}
                                        onClickViewAll={onClickViewAll}
                                        type={HomePageCarouselType.PRACTICE}
                                        filterType={selectedTab==0?HomePageCarouselFilter.ALL:(selectedTab==1?HomePageCarouselFilter.GST:HomePageCarouselFilter.INCOME_TAX)}
                                        isfilter={true}
                                        isVideos={false}
                                        filterData={practiceFilterData}
                                        filterSelectedPracticeTab={filterSelectedPracticeTab}
                                    />
                                </div>
                                </>
                                : 
                                practiceTopicLoading ?
                                <OfferCardShimmer />
                                :''
                        }

                        {
                            learningVideosData?.length ?                          
                                <div ref={videosRef} className={`video_learnings_1 section-offset ${stickyElement === "videos" ? "fully-sticky" : ""}`}>
                                  <div className='section-indicator-1'> 03/<span className='text-light-1'>03</span> 
                                  <svg width="25" height="15" viewBox="0 0 25 15" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M24.7071 8.20711C25.0976 7.81658 25.0976 7.18342 24.7071 6.79289L18.3431 0.428932C17.9526 0.0384078 17.3195 0.0384078 16.9289 0.428932C16.5384 0.819457 16.5384 1.45262 16.9289 1.84315L22.5858 7.5L16.9289 13.1569C16.5384 13.5474 16.5384 14.1805 16.9289 14.5711C17.3195 14.9616 17.9526 14.9616 18.3431 14.5711L24.7071 8.20711ZM0 8.5H24V6.5H0V8.5Z" fill="#287682"/>
</svg>

 </div>
                                    <LoginOfferCards
                                      title={"Learning"}
                                      apiresponse={learningVideosData}
                                      showReadMore={false}
                                      isVideos={true}
                                      numVisible={4}
                                      showprice={true}
                                      onClickViewAll={onClickViewAll}
                                      type={HomePageCarouselType.VIDEO}
                                      isfilter={true}
                                      filterData={learningFilterData}
                                      filterSelectedLearningTab={filterSelectedLearningTab} 
                                      filterType={''}                                    />
                                </div>                               
                                : 
                                learningVideosLoading ?
                                <OfferCardShimmer />
                                :''
                        }

                    </div>
                    </div>
                </div>

            </div>
            </ParallaxProvider>
        </>
    )
}